import styled from 'styled-components';
import {ellipsis, BGImageCenter} from '../../../globalVariables/GlobalVariables';
import {arrowDown} from '../../../assets/symbols/symbols/Symbols.css';
import * as inputClasses from '../../classes/input';

export const container = inputClasses.container;
export const icon = inputClasses.icon;
export const wrap = inputClasses.wrap;
export const disabledInput = styled(inputClasses.input) `
  ${ellipsis}
  font-weight:${inputClasses.INPUT_WEIGHT} ;
  &.hasArrow{
    padding-inline-end: 16px;
    &::after{
      content: '';
      position: absolute;
      inset-inline-end: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 10px;
      height: 7px;
      pointer-events: none;
      ${BGImageCenter(arrowDown, 'contain')}
    }
  }
`;
export const title = inputClasses.title;
